<script setup lang="ts">
import type { IProps } from './Hero.types'

defineProps<IProps>()
</script>

<template>
  <section :class="['investorHero', { 'investorHero--noImage': !image }]">
    <div class="investorHero__inner">
      <div class="investorHero__content">
        <!--
        <div
          v-if="mainCategory"
          class="investorHero__breadcrumbs"
        >
          <NuxtLink
            class="investorHero__mainCategoryLink"
            :to="mainCategory.url"
            :aria-label="mainCategory.aria"
          >
            {{ mainCategory.label }}
          </NuxtLink>

          <span v-if="secondCategory">
            /
          </span>

          <NuxtLink
            v-if="secondCategory"
            class="investorHero__secondCategoryLink"
            :to="secondCategory.url"
            :aria-label="secondCategory.aria"
          >
            {{ secondCategory.label }}
          </NuxtLink>
        </div>
        -->

        <h1 class="investorHero__title">
          {{ title }}
        </h1>

        <p
          v-if="lead"
          class="investorHero__lead"
        >
          {{ lead }}
        </p>

        <div
          v-if="firstButton || secondButton"
          class="investorHero__buttons"
        >
          <UiButton
            v-if="firstButton"
            class="investorHero__button"
            size="big"
            :variant="firstButton?.variant ?? 'primary'"
            :target="firstButton?.target"
            :to="firstButton.to"
          >
            <slot name="firstButton" />
            {{ firstButton.text }}
          </UiButton>
  
          <UiButton
            v-if="secondButton"
            class="investorHero__button"
            size="big"
            :variant="secondButton?.variant ?? 'primary'"
            :target="secondButton?.target"
            :to="secondButton.to"
          >
            <slot name="secondButton" />
            {{ secondButton.text }}
          </UiButton>
        </div>
      </div>

      <img
        v-if="image"
        class="investorHero__image"
        :src="image"
        :aria-hidden="true"
      >
    </div>
  </section>
</template>

<style lang="scss" scoped>
.investorHero {
  position: relative;
  overflow: hidden;
  background-color: $violet-200;
  background-image: url('/images/investor/components/Hero.jpg');
  background-position: center;
  background-size: cover;
  border-radius: 0 0 2.4rem 2.4rem;

  &__inner {
    position: relative;
    display: flex;
    flex-direction: column;
    width:100%;
    margin: 0 auto;
    padding: 12rem 2.4rem 0;
  }

  &--noImage &__inner {
    padding-bottom: 6.4rem;
  }

  &__buttons {
    width: 100%;
  }

  /*
  &__breadcrumbs {
    @include body-3;
    display: flex;
    gap: .8rem;
    margin-bottom: 2.4rem;
    color: $text-200;
  }

  &__mainCategoryLink {
    @include body-3;
    color: $text-200;
  }

  &__secondCategoryLink {
    @include body-3;
    color: $text-400;
  }
  */

  &__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__title {
    @include h5;
    margin-bottom: 1.2rem;
    color: $text-400;
  }

  &__lead {
    @include body-2;
    color: $text-400;
  }

  &__button {
    display: flex;
    gap: .8rem;
    width: 100%;
    margin-top: 2.4rem;
  }

  &__image {
    display: block;
    max-width: 56rem;
    width: 100%;
    margin: 4rem auto 0;
  }

  @include atXS {
    &__inner {
      padding: 12rem 6.4rem 0;
    }

    &__button {
      width: auto;
    }
    
    &__buttons {
      display: flex;
      gap: 1.2rem;
      width: fit-content;
    }
  }

  @include atM {

    &__inner {
      justify-content: center;
      max-width: calc($investor-content-max-width + (9.6rem * 2));
      height: 65rem;
      padding: 17rem 9.6rem 0;
    }

    &--noImage &__inner {
      padding-bottom: 0;
    }

    &__content {
      max-width: 49rem;
    }

    &__image {
      position: absolute;
      right: 9.6rem;
      bottom: 0;
      max-width: 48%;
      width: auto;
      max-height: calc(100% - 17rem);
      height: auto;
      margin: 0;
      object-fit: contain;
      object-position: bottom right;
    }
  }
}
</style>
